import React, { useRef, useEffect, useState } from "react";
import jsPDF from 'jspdf';
import moment from "moment";
import html2canvas from 'html2canvas';
import logo from '../../../img/logo-cpa.png'
import logoQuiniela from '../../../img/logo-quiniela-prueba.png'
import ConsultasAPI from "../../../shared/helpers/consultasAPI";
import PrintIcon from '@mui/icons-material/Print';
import { IconButton } from '@mui/material';

const SorteoComponent = (props) => {
  const contentRef = useRef();
  const datos_sorteo = props.datos[0]
  const registros = props.datos
  const URL_INCIDENTE = window.API_ROUTES.INCIDENTE;
  const URL_AUTORIDADES = window.API_ROUTES.AUTORIDADES;
  const URL_PARAMETROMONTOS = window.API_ROUTES.PARAMETROMONTOS;
  const [escribano, setEscribano] = useState('');
  const [interventor, setInterventor] = useState('');
  const [subinterventor, setSubInterventor] = useState('');
  const [gerente_gral, setGerenteGral] = useState('');
  const [montos, setMontos] = useState([]);
  const [tieneEscribano, setTieneEscribano] = useState(false)
  const [allowDownload, setAllowDownload] = useState(false)
  useEffect(() => {
    obtenerData();
  }, [datos_sorteo]);

  const downloadPDF = async () => {
    const content = contentRef.current;

    // Definir un tamaño fijo para html2canvas
    const canvas = await html2canvas(content, {
      scale: 3, // aumenta la resolución para que el texto sea nítido
      width: 595, // Ancho en px (A4 a 72 DPI es 595px de ancho)
      height: 842, // Alto en px (A4 a 72 DPI es 842px de alto)
    });
    const imgData = canvas.toDataURL("image/png");

    // Crear el PDF con dimensiones específicas de A4
    const pdf = new jsPDF("p", "mm", "a4");
    pdf.addImage(imgData, "PNG", 0, 0, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight());
    pdf.save("sorteo.pdf");
  };

  const obtenerData = async () => {
    const escribano = await ConsultasAPI.ObtenerObjeto(
      URL_INCIDENTE,
      "?numero_sorteo=" + datos_sorteo.sorteo
    );
    if (escribano.status === 200 && escribano.data.escribano_data) {
      setEscribano(escribano.data.escribano_data);
      setTieneEscribano(false)
    };
    const autoridades = await ConsultasAPI.ObtenerObjeto(URL_AUTORIDADES, "?fecha_sorteo=" + moment(datos_sorteo.fecha, "DD/MM/YYYY").format("YYYY-MM-DD"));
    if (autoridades.status === 200) {
      autoridades.data.forEach(autoridad => {
        if (autoridad.tipo === 1) {
          setInterventor(autoridad.nombre + ' ' + autoridad.apellido);
        } else if (autoridad.tipo === 2) {
          setSubInterventor(autoridad.nombre + ' ' + autoridad.apellido);
        } else {
          setGerenteGral(autoridad.nombre + ' ' + autoridad.apellido);
        };
      });
    };
    const parametros_montos = await ConsultasAPI.ObtenerObjeto(URL_PARAMETROMONTOS, "?fecha_sorteo=" + moment(datos_sorteo.fecha, "DD/MM/YYYY").format("YYYY-MM-DD"));
    if (parametros_montos.status === 200) {
      setMontos(parametros_montos.data);
    };
    if (autoridades.status === 200 && parametros_montos.status === 200) {
      setAllowDownload(true);
    }else {
      setAllowDownload(false);
    };
  };
  const formatFecha = (fecha) => {
    if (!fecha) return ""; // Manejo de valores nulos o indefinidos

    // Detectar si viene en formato yyyy-mm-dd
    if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
      const [year, month, day] = fecha.split("-");
      return `${day}/${month}/${year}`;
    }

    // Detectar si ya está en formato dd/mm/yyyy
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(fecha)) {
      return fecha; // Ya está en el formato deseado
    }

    // Intentar parsear con Date (para otros formatos)
    const date = new Date(fecha);
    if (!isNaN(date)) {
      return date.toLocaleDateString("es-ES"); // Devuelve en formato dd/mm/yyyy
    }

    return "Fecha inválida"; // En caso de que el formato no sea reconocible
  };
  return (

    <div >
      <div ref={contentRef} style={{
        width: "595px", height: "842px",
        position: 'absolute',
        left: '-9999px',
      }}>
        <div style={{ padding: '10px' }}>
          <h style={{ display: 'flex', justifyContent: 'center' }}>
            <img
              style={{ width: '135px' }}
              src={logo}
              alt=""
            />
          </h>
          <hr style={{ border: "none", borderTop: "3px solid black", margin: '0px' }} />
          <table style={{ height: "10px", width: "100%", marginLeft: '20px' }}>
            <tbody>
              <tr style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <td style={{ width: "100%" }}>
                  <td style={{ fontSize: '35px', fontWeight: 'bolder' }}>EXTRACTO</td>
                </td>
                <td style={{ width: "100%", display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', height: '100%', marginTop: '7px' }}>
                  <td style={{ fontSize: '10px' }}>SORTEO N° :&nbsp;&nbsp;</td>
                  <td style={{ fontSize: '35px', fontWeight: 'bolder', marginTop: '-6px' }}>{datos_sorteo.sorteo}</td>
                </td>
                <td style={{ width: "100%" }}>
                  <img
                    style={{ display: "block", marginLeft: "auto", marginRight: "auto", width: '85px' }}
                    src={logoQuiniela}
                    alt=""
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <hr style={{ border: "none", borderTop: "3px solid black", width: "100%", margin: '0px' }} />
          <table style={{ height: "15px", width: "100%" }}>
            <tbody>
              <tr>
                <td colSpan="2" style={{ width: "100%" }}>
                  <h3 style={{ textAlign: "center", fontStretch: 'expanded', fontSize: '14px', fontFamily: 'Montserrat-pdf' }}>
                    REALIZADO EL{" "}
                    {moment(datos_sorteo.fecha, "DD/MM/YYYY").format("DD")} DE{" "}
                    {moment(datos_sorteo.fecha, "DD/MM/YYYY").format("MMMM").toUpperCase()} DE{" "}
                    {moment(datos_sorteo.fecha, "DD/MM/YYYY").format("YYYY")} {" - "}A HORAS{" "}
                    {moment(datos_sorteo.hora, "HH:mm").format("HH:mm")}
                  </h3>
                </td>
              </tr>
              <tr>
                <td >
                  <h1 style={{ textAlign: "center", fontFamily: 'Black-Regular', fontSize: '45px', height: '42px' }}>SORTEO {datos_sorteo.tipo}</h1>
                </td>
              </tr>
              <tr>
                <td style={{ width: "100%", height: '16px' }}>
                  <h3 style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: "center", backgroundColor: "#129594", fontSize: '10px', color: 'white', fontFamily: 'Montserrat', height: '16px' }}>
                    PROHIBIDA SU REPRODUCCIÓN O UTILIZACIÓN SIN EXPRESA AUTORIZACIÓN DEL ENTE EMISOR
                  </h3>
                </td>
              </tr>
            </tbody>
          </table>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr style={{ height: "20px" }}>
                <td style={{ fontSize: "10px", width: '50%', borderRight: '15px solid transparent' }}>
                  <tr style={{ display: 'contents', width: "100%" }}>
                    <hr style={{ border: "none", borderTop: "3px solid black", width: "100%", margin: '0px' }} />
                    <table style={{ width: "100%" }}>
                      <tbody>
                        {registros.map((record, index) => (
                          <tr style={{ backgroundColor: index % 2 === 0 ? '#f2f2f2' : '#d8d8d8' }}>
                            <td style={{ textAlign: 'center' }}>{record.numPremio1_10.toUpperCase()}</td>
                            <td >
                              <t style={{ fontFamily: 'Black-Regular', fontSize: '15px' }}>{record.numero1_10}</t>
                            </td>
                          </tr>
                        ))}
                        {registros.map((record, index) => (
                          <tr style={{ backgroundColor: index % 2 === 0 ? '#f2f2f2' : '#d8d8d8' }}>
                            <td style={{ textAlign: 'center' }}>{record.numPremio11_20.toUpperCase()}</td>
                            <td >
                              <t style={{ fontFamily: 'Black-Regular', fontSize: '15px' }}>{record.numero11_20}</t>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <hr style={{ border: "none", borderTop: "3px solid black", width: "100%", margin: '0px' }} />
                  </tr>
                  <td style={{ width: "100%", display: 'flex', flexDirection: 'column', backgroundColor: '#666666', marginTop: '5px' }}>
                    <tr style={{ textAlign: 'center', fontSize: '7px', color: 'white' }}>AUTORIDADES</tr>
                  </td>
                  <tr style={{ display: 'flex', width: "100%" }}>
                    <td style={{ width: "100%", display: 'flex', flexDirection: 'column' }}>
                      <td style={{ width: "100%", display: 'flex', flexDirection: 'column' }}>
                        <tr style={{ textAlign: 'center', fontSize: '6px', fontWeight: 'bold' }}>{interventor}</tr>
                        <tr style={{ textAlign: 'center', fontSize: '6px', fontWeight: 'bold' }}> Interventor</tr>
                      </td>
                      <td style={{ width: "100%", display: 'flex', flexDirection: 'column' }}>
                        <tr style={{ textAlign: 'center', fontSize: '6px', fontWeight: 'bold' }}>{gerente_gral}</tr>
                        <tr style={{ textAlign: 'center', fontSize: '6px', fontWeight: 'bold' }}> Gerente General(Int.)</tr>
                      </td>
                    </td>
                    <td style={{ width: "100%", display: 'flex', flexDirection: 'column' }}>
                      <td style={{ width: "100%", display: 'flex', flexDirection: 'column' }}>
                        <tr style={{ textAlign: 'center', fontSize: '6px', fontWeight: 'bold' }}>{subinterventor}</tr>
                        <tr style={{ textAlign: 'center', fontSize: '6px', fontWeight: 'bold' }}>Sub. Interventor</tr>
                      </td>
                      {tieneEscribano ?
                        <td style={{ width: "100%", display: 'flex', flexDirection: 'column' }}>
                          <tr style={{ textAlign: 'center', fontSize: '6px', fontWeight: 'bold' }}>{escribano}</tr>
                          <tr style={{ textAlign: 'center', fontSize: '6px', fontWeight: 'bold' }}>Escribano</tr>
                        </td>
                        :
                        null
                      }
                    </td>
                  </tr>
                </td>
                <td style={{ fontSize: "10px", }}>
                  <tr style={{ top: 0, marginLeft: '20px' }}>
                    {/* <div style={{ border: "none", borderTop: "5px solid #129594", width: "270px", margin: '0px' }} /> */}
                    <table style={{ width: "270px", height: '500px' }}>
                      <tbody style={{ position: 'relative', top: '0px' }}>
                        <tr style={{ borderTop: "3px solid #c4e4e4", borderBottom: "3px solid #c4e4e4", height: '130px' }}>
                          <tr style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '296px', marginTop: '2px', height: '45px' }}>
                            <td style={{ textAlign: "center", width: '296px', top: 0 }}>
                              <div style={{
                                textAlign: "center",
                                alignItems: 'center',
                                width: '170px',
                                fontFamily: 'Black-Regular',
                                fontSize: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                // marginTop: '8px',
                                background: '#129594',
                                borderRadius: '10px',
                                height: '35px',
                                color: 'white'
                              }}>
                                TRIPLONA
                              </div>
                            </td>
                            <td style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', width: '290px' }}>
                              <tr style={{ fontFamily: 'Black-Regular', color: '#129594', fontSize: '15px' }}>{datos_sorteo.tipo}</tr>
                              <tr style={{ fontFamily: 'Black-Regular', color: '#626060', fontSize: '10px' }}>{datos_sorteo.fecha}</tr>
                            </td>
                          </tr>
                          <tr style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '290px' }}>
                            <td colSpan="2" style={{ textAlign: "center", alignItems: 'center', width: '290px', fontFamily: 'Black-Regular', fontSize: '50px', display: 'flex', justifyContent: 'center' }}>
                              <td style={{ fontSize: '20px' }}>
                                $
                              </td>
                              <td>
                                {montos.triplona ?
                                  montos.triplona.toLocaleString('ES-AR')
                                  :
                                  ''
                                }
                              </td>
                            </td>
                          </tr>
                        </tr>
                        <tr >
                          <tr style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '296px', marginTop: '5px' }}>
                            <td style={{ textAlign: "center", width: '296px', top: 0 }}>
                              <div style={{
                                textAlign: "center",
                                alignItems: 'center',
                                width: '170px',
                                fontFamily: 'Black-Regular',
                                fontWeight: 'bolder',
                                fontSize: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                // marginTop: '8px',
                                background: '#129594',
                                borderRadius: '10px',
                                height: '35px',
                                color: 'white'
                              }}>
                                CUATRIPLONA
                              </div>
                            </td>
                            <td style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', width: '296px' }}>
                              <tr style={{ fontFamily: 'Black-Regular', color: '#129594', fontSize: '15px' }}>{datos_sorteo.tipo}</tr>
                              <tr style={{ fontFamily: 'Black-Regular', color: '#626060', fontSize: '10px' }}>{datos_sorteo.fecha}</tr>
                            </td>
                          </tr>
                          <tr style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '290px' }}>
                            <td colSpan="2" style={{ textAlign: "center", alignItems: 'center', width: '290px', fontFamily: 'Black-Regular', fontSize: '50px', display: 'flex', justifyContent: 'center' }}>
                              <td style={{ fontSize: '20px' }}>
                                $
                              </td>
                              <td>

                                {montos.cuatriplona ?
                                  montos.cuatriplona.toLocaleString('ES-AR')
                                  :
                                  ''
                                }
                              </td>
                            </td>
                          </tr>
                        </tr>
                      </tbody>
                    </table>
                  </tr>
                  <tr style={{ display: 'flex', border: '4px solid #129594', marginTop: '-245px', marginBottom: '0' }}>
                    <tr style={{ textAlign: "center", fontSize: "21px", width: '286px', fontFamily: 'Black-Regular' }}>
                      <h >Monto de Apuesta</h>
                    </tr>
                  </tr>
                  <tr style={{ display: 'flex' }}>
                    <tr style={{ backgroundColor: "#129594", textAlign: "center", fontSize: "12px", letterSpacing: '0.1em', width: '296px', fontWeight: 'bolder', color: 'white', fontFamily: 'Black-Regular', display: 'flex', flexDirection: 'column', padding: '7px' }}>
                      <h style={{ marginBottom: '0' }}>Minimo por rengl&oacute;n : ${montos.minimo_renglon}</h>
                      <h> Minimo por boleta: ${montos.minimo_boleta}</h>
                    </tr>
                  </tr>
                  <table >
                    <tr>
                      <td style={{ textAlign: 'justify', fontSize: '8px', border: '2px solid #129594', padding: '5px', fontFamily: 'Montserrat-pdf', fontWeight: 'bold' }}>
                        El deterioro o adulteraci&oacute;n del ticket de apuesta no genera al portador derecho a cobrar
                        premios. No se aceptará reclamo por pérdidas, sustracci&oacute;n u otra causa que se alegue. Este extracto
                        fija irrevocablemente los derechos de los apostadores. Reglamentación del juego de quinielas, aprobada
                        por Resolución de Interveción N&deg; 026/06, conforme a las facultades conferidas por el Inc. M Art. 15
                        de la Ley N&deg;5115, Carta Org&aacute;nica de la institución. IMPORTANTE: Al cobrar su premio solicite el
                        ticket correspondiente.
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: 'justify', fontSize: '7px', borderBottom: '2px solid #129594', borderLeft: '2px solid #129594', borderRight: '2px solid #129594', borderTop: '5px solid #129594', padding: '5px', fontFamily: 'Montserrat-pdf' }}>
                        <p style={{ marginBottom: '0px', fontSize: '5.6px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          Los aciertos COMUNES correspondientes al dia de la fecha caducan:
                          <span style={{ fontSize: '9px', fontWeight: 'bold', marginLeft: '5px' }}>
                            {formatFecha(datos_sorteo.caducidad_quiniela)}
                          </span>
                        </p>
                        <p style={{ marginBottom: '0px', fontSize: '5.6px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          El derecho al cobro del Premio de TRIPLONA caducara indefectiblemente el:
                          <span style={{ fontSize: '9px', fontWeight: 'bold', marginLeft: '5px' }}>
                            {formatFecha(datos_sorteo.caducidad_triplona)}
                          </span>
                        </p>
                        <p style={{ marginBottom: '0px', fontSize: '5.4px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          El derecho al cobro del Premio de CUATRIPLONA caducara indefectiblemente el:
                          <span style={{ fontSize: '9px', fontWeight: 'bold', marginLeft: '5px' }}>
                            {formatFecha(datos_sorteo.caducidad_cuatriplona)}
                          </span>

                        </p>
                        <p style={{ marginBottom: '0px', fontSize: '5.6px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          Cuando la caducidad opere en dia feriado, o no laborable, la fecha de vencimiento se hara extensiva al
                          primer dia habil siguiente.
                        </p>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <tr style={{ height: "50px", fontSize: '13px', fontFamily: 'Black-Regular', fontWeight: 'bolder', backgroundColor: '#666666', color: 'white', display: 'flex', padding: '10px', textAlign: 'center', justifyContent: 'center' }}>
            <h style={{ marginTop: '-4px' }}>
              El JUEGO COMPULSIVO ES PERJUDICIAL PARA LA SALUD. <br />SI NECESITA AYUDA, LLAMAR AL 08005557678 LEY 8986
            </h>
          </tr>
        </div>
      </div>
      {
        allowDownload ?
          <IconButton onClick={downloadPDF} title="Imprimir">
            <PrintIcon style={{ color: '#ffffff', fontSize: '140%' }} />
          </IconButton>
          :
          null
      }
    </div>
  );
};

export default SorteoComponent;
